export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_URL ||
  "http://localhost:8000";
export const API_CORE = `${API_BASE_URL}/api/core`;

export const WS_BASE_URL =
  process.env.REACT_APP_WS_BASE_URL ||
  process.env.VITE_WS_URL ||
  "ws://localhost:8000";

export const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL ||
  process.env.VITE_FRONTEND_URL ||
  "http://localhost:5173";

export const DASHBOARD_URL =
  process.env.REACT_APP_DASHBOARD_URL ||
  process.env.VITE_DASHBOARD_URL ||
  "http://localhost:5174";

export const GAME_DEFAULTS = {
  MIN_PLAYERS: 2,
  MAX_PLAYERS: 20,
  ROUND_SECONDS: 20,
  BREAK_SECONDS: 10,
};
